import { createFileRoute } from "@tanstack/react-router";

import OnboardingView from "./-components/OnboardingView";

export const Route = createFileRoute("/_authenticated/onboarding/$step")({
  component: OnboardingView,
  context: () => ({ permissions: "onboarding" }),
});
